import React from 'react';
import Logo from './images/money_logo.svg';
import { ClickableProps, StylableProps } from '../../../types/props';

export const MoneyLogo = ({ className, onClick }: StylableProps & ClickableProps) => {
  return <img id="money-logo" className={className} src={Logo} onClick={onClick} />;
};
